import React from "react";
import { Text, Button } from "react_reusable_components";
import { ThreeRow } from "../../core/layouts";
import variables from "../../themes/base/styles/variables";
import Style from "./EvidenceContainerStyles.module.scss";

const EvidenceContainerStyle = {
  bottomSectionStyle: {
    gap: variables.gapSmaller,
    display: variables.dFlex,
    width: variables.fullWidth,
    flexWrap: "wrap",
    overflow: "unset",
    flexDirection: variables.flexDirection,
  },
};
const EvidenceContainer = ({
  heading,
  buttonLabel,
  buttonIcon,
  onButtonClick,
  bottomSectionComponent,
  hideAction,
  disabled,
}) => {
  return (
    <ThreeRow
      style={{ gap: variables.gapSmaller }}
      topSection={
        <Text type="secondary" className={Style["heading"]}>
          {heading}
        </Text>
      }
      middleSectionStyle={{ ...(hideAction && { display: "none" }) }}
      middleSection={
        <Button
          className={`${Style["btn-style"]} ${
            disabled && Style["btn-style-disabled"]
          }`}
          ghost
          icon={
            <img
              src={buttonIcon}
              alt="ic"
              style={{
                width: variables.iconWidth,
                height: variables.iconHeight,
              }}
            />
          }
          onClick={onButtonClick}
          disabled={disabled}
        >
          {buttonLabel}
        </Button>
      }
      bottomSectionStyle={EvidenceContainerStyle.bottomSectionStyle}
      bottomSection={bottomSectionComponent}
    />
  );
};

export default EvidenceContainer;
